<template>
  <el-container>
    <el-header height="auto">
      <headerPage @resetScrollTop="resetScrollTop" />
    </el-header>
    <el-main id="pageMain" class="pageMain">
      <router-view @resetScrollTop="resetScrollTop">
        <template slot="breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">{{$t('route.Home')}}</el-breadcrumb-item>
            <el-breadcrumb-item
              :to="{ path: item.rePath || item.path }"
              v-for="(item, index) in breadList"
              :key="index"
            >
              {{ item.name }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </template>
      </router-view>
      <login ref="login" @loginSuccess="loginSuccess" />
      <footerPage @resetScrollTop="resetScrollTop" />
    </el-main>
    <!-- <el-footer class="hidden-xs-only" height="100px">
		<footerPage />
	</el-footer> -->
  </el-container>
</template>

<script>
import "element-ui/lib/theme-chalk/display.css";
import headerPage from "./components/headerPage.vue";
import footerPage from "./components/footerPage.vue";
import login from "@/views/login/login.vue";
import { readChange } from "@/api/home";

export default {
  name: "app",
  components: { headerPage, footerPage, login },
  data() {
    return {
      breadList: [],
    };
  },
  watch: {
    $route: {
      handler(to, from) {
        this.getBreadcrumb(to.fullPath, from.fullPath);
        if (to.meta.requireLogin) {
          if (!localStorage.getItem("xy-web-token")) {
            this.$refs.login.open();
            this.$router.go(-1);
          }
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getBreadcrumb();
    this.toGray();
  },
  methods: {
    getBreadcrumb(nowPath, fromPath) {
      this.breadList = [];
      const findNameByPath = (path, router) => {
        return router.reduce((matches, route) => {
          if (route.regex && route.regex !== null) {
            if (path.replace(route.regex, "") === route.path) {
              matches.push({
                name: route.name,
                path: route.path,
                rePath: route.rePath || null,
                regex: route.regex || null,
              });
            }
          } else if (route.path === path) {
            matches.push({
              name: route.name,
              path: route.path,
              rePath: route.rePath || null,
              regex: route.regex || null,
            });
          } else if (route.children && route.children.length > 0) {
            const childMatches = findNameByPath(path, route.children);
            if (childMatches.length > 0) {
              matches.push({
                name: route.name,
                path: route.path,
                rePath: route.rePath || null,
                regex: route.regex || null,
                children: childMatches,
              });
            }
          }
          return matches;
        }, []);
      };

      const result = findNameByPath(
        this.$route.fullPath,
        this.$store.state.user.routerPath
      );
      const saveName = (param) => {
        if (param.length > 1) {
          param.forEach((item) => {
            if (item.path === fromPath) {
              this.breadList.push(item);
              if (item.children) {
                saveName(item.children);
              }
            } else if (item.path === nowPath.replace(item.regex, "")) {
              if (this.breadList.findIndex((i) => i.path === item.path) == -1) {
                this.breadList.push(item);
              }
            }
          });
        } else {
          this.breadList.push(param[0]);
          if (param[0].children) {
            saveName(param[0].children);
          }
        }
      };
      if (result && result.length > 0) {
        saveName(result);
        document.title=this.breadList[this.breadList.length-1].name
      }
    },
    resetScrollTop(Element) {
      this.$nextTick(() => {
        Element
          ? this.$el.querySelector(`.${Element}`).scrollIntoView()
          : (document.getElementById("pageMain").scrollTop = 0);
      });
    },
    toGray() {
      readChange()
        .then((res) => {
          if (res.code == 0) {
            if (res.data.change_grey == 1) {
              let box = document.getElementsByTagName("html")[0];
              box.setAttribute("class", "o2_gray");
            }
          }
        })
        .catch((err) => {});
    },
    loginSuccess() {
      this.$router.go(0);
    },
  },
};
</script>

<style>
.o2_gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  -webkit-filter: gray;
  filter: gray;
  -webkit-filter: progid:dximagetransform.microsoft.basicimage(grayscale=1);
  filter: progid:dximagetransform.microsoft.basicimage(grayscale=1);
}
img {
  display: block;
}
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
}
.container {
  min-height: calc(100vh - 244px);
}
.el-header,
.el-main,
.el-footer {
  padding: 0 !important;
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 800 !important;
  pointer-events: none;
}

.el-breadcrumb__inner a,
.el-breadcrumb__inner.is-link {
  font-weight: 400 !important;
}
/* 弹出菜单样式 */
.submenuColor > ul {
  background-color: #ffffff !important;
  color: #333333 !important;
  border-radius: 10px;
  overflow: hidden;
  padding: 0;
}
.submenuColor.product > ul {
  margin-left: -150px !important;
}
.submenuColor > ul li {
  background-color: #ffffff !important;
  color: #333333 !important;
  height: 46px !important;
  line-height: 46px !important;
  text-indent: 20px;
  /* border-radius: 10px; */
}
.submenuColor > ul li:hover {
  color: #32589f !important;
  font-weight: 800;
  /* max-width: 240px; */
  background-color: rgba(235, 246, 252, 1) !important;
}
/* sweiper指示点样式 */
.swiper-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
}
.my-bullet {
  width: 10px;
  height: 10px;
  background: #ffffff;
  display: block;
  margin: 0 10px;
  transition: all 0.2s;
  border-radius: 10px;
  border: 1px solid #409eff;
  cursor: pointer;
}
.my-bullet-active {
  width: 30px;
  height: 10px;
  background: #409eff;
  border-color: #ffffff7d;
}
/* 轮播指示点样式 */

@media only screen and (max-width: 768px) {
  .pageMain {
    width: 100%;
    height: calc(100vh - 70px);
    overflow: hidden;
    overflow-y: scroll;
  }
  .my-bullet {
    width: 8px;
    height: 8px;
    margin: 0 5px;
  }
  .my-bullet-active {
    width: 20px;
  }
}
@media screen and (min-width: 768px) {
  .pageMain {
    width: 100%;
    height: calc(100vh - 130px);
    overflow: hidden;
    overflow-y: scroll;
  }
}
</style>
<style scoped>
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  text-align: center;
  border-radius: 4px;
  line-height: 60px;
  height: 60px;
  margin: 5px 0;
}
</style>
